<header [class.admin]="IsAdmin">
  <nav class="navbar">
    <div class="container-fluid justify-content-between">
      @if (!loading && environmentID) {
        <div class="nav-brand">
          @if (isUserLoggedIn) {
            @if (environmentID === Environment.PROD && theme && theme.logoURL) {
              <a [routerLink]="['/admin/dashboard']" (click)="navigateToDashboard()" class="color-logo" style="display: block"
                >
                <img [src]="theme.logoURL | safeUrl" alt="Client Logo" />
              </a>
            } @else {
              @if (environmentID) {
                <a [routerLink]="['/admin/dashboard']" (click)="navigateToDashboard()" class="color-logo">
                  <img [src]="getIchraxLogoForCurrentEnvironment()" alt="ichrax logo" />
                </a>
              }
            }
          }
          @if (showEnvironmentBadge) {
            <span class="sr-only">Environment:</span>
            <app-pill [status]="environmentPillStatus" [text]="environmentLabel" compact></app-pill>
          }
        </div>
      }
      <div class="header-search-wrapper d-none d-lg-flex">

      </div>

      @if (!isLoginPage) {
        <div class="navbar-nav primary-nav" #headerNav>
          <!-- desktop button -->
          @if (isUserLoggedIn) {
            <button class="header-authenticated-user btn btn-naked d-none d-md-block" (click)="dropdown.toggle($event)" type="button"
              [attr.aria-expanded]="dropdown.visible" aria-haspopup="true" [attr.aria-controls]="dropdown.visible ? 'desktop-menu' : null" aria-label="User menu"
            >
              <ng-container *ngTemplateOutlet="menuButton"></ng-container>
            </button>
          }
          <p-menu #dropdown [popup]="true" [model]="menuItems" styleClass="primary-menu"
            [appendTo]="headerNav"
            [id]="'desktop-menu'"
            ></p-menu>
          <!-- mobile button -->
          @if (isUserLoggedIn) {
            <button #mobileToggle class="header-authenticated-user btn btn-naked header-authenticated-user--mobile d-xs-block d-md-none"
              (click)="showMobileMenu = !showMobileMenu" type="button"
              [attr.aria-expanded]="showMobileMenu" [attr.aria-controls]="showMobileMenu ? 'mobile-menu' : null" aria-haspopup="true">
              <ng-container *ngTemplateOutlet="menuButton"></ng-container>
            </button>
          }
          <!-- flyout menu button content - template -->
          <ng-template #menuButton>
            <span class="d-flex align-items-center">
              <span class="user-initials user1 small-circle mr-2">{{ userInitials }}</span>
              <span class="user-name-container text-medium mr-2">{{ userDisplayName }}</span>
              <i class="fa fa-chevron-down text-small"></i>
            </span>
          </ng-template>
              <!-- login button -->
              @if (!isUserLoggedIn) {
                <a class="header-login" [href]="[this.loginURL + '/dashboard']">
                  Login/Register
                </a>
              }
            </div>
          }
      </div>
      <!-- mobile flyout menu -->
      @if (showMobileMenu) {
        <div class="mobile-menu full-width" #mobileMenu (window:resize)="showMobileMenu = false">
          <p-menu #dropdown [popup]="false" [model]="menuItems" class="full-width" [id]="'mobile-menu'"></p-menu>
          @if (isUserLoggedIn && IsAdmin) {
            <app-left-nav class="full-width"
            ></app-left-nav>
          }
        </div>
      }
    </nav>
  </header>
